<template>
  <section>
    <VerAsistencia/>
    <AprobarAsistencia/>
   <VerDocumento/>
   <VerReporte/>
   <!--
    <h3 class="primary--text">
      <v-icon info>exit_to_app</v-icon>Listado de registro de asistencia manual
    </h3>
    <h4 style="color:#000">
      <b>NOMBRE COMPLETO:</b> <v-spacer></v-spacer> {{nombres}}
     
    </h4>-->
    <v-card>
 <v-card-text class="grey lighten-2 text--info">
        <v-layout wrap>
          <v-flex class="px-3">
            <v-btn
              icon
              color="primary"
              :to="`/registro-manual-asistencia/`"
            >
              <v-icon>arrow_back</v-icon>
            </v-btn>
             <h3 class="primary--text">
                <v-icon info>exit_to_app</v-icon>Listado de registro de asistencia manual autoridad
              </h3>
              <h4 style="color:#000">
                <b>NOMBRE COMPLETO:</b> <v-spacer></v-spacer> {{nombres}}
              
              </h4>
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-card-text>

        <crud-table
          :headers="headers"
          :url="url"
          :filters="filters"
          :graphql="graphql"
          :data-graphql="dataGraphql"
          :initData="initData"
          :widthModal="840"
        >
    
          <template slot="buttons">
            <v-tooltip bottom>
              <v-btn
                color="primary"
                :to="`/registro-manual-asistencia-autoridad/crear/${this.esUsuario}/`"
                slot="activator"
                ><v-icon>add</v-icon> Nuevo</v-btn
              >
              <span>{{ $t("user.add") }}</span>
            </v-tooltip>
          </template>

          <template slot="items" slot-scope="items">
            <td>{{ items.item.id }}</td>
            <td>{{ items.item.fecha_registro }}</td>
            <td>{{ items.item.fecha_inicio }}</td>
            <td>{{ items.item.fecha_fin }}</td>
            <td>{{ items.item.estado }}</td>
            <td>
              <v-btn
                color="info"
                @click.prevent="verAsistencia(items.item)"
                icon
                title="Ver permiso"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
                 <!-- <v-btn
              color="#F58736"
                @click.prevent="verReporte(items.item)"
                icon
                title="Ver reporte"
              >
                <v-icon>picture_as_pdf</v-icon>
              </v-btn> -->
             <v-btn 
                v-if="items.item.id_estado!=9"
                color="warning"
                :to="`/registro-manual-asistencia-autoridad/editar/${items.item.id_persona}/${items.item.id}`"
                icon
                title="Modificar"
              >
                <v-icon>edit</v-icon>
                
              </v-btn>
               <v-btn
                v-if="items.item.id_estado!=9"
                color="red"
                @click.prevent="anularAsistencia(items.item.id)"
                icon
                title="Anular"
              >
                <v-icon>delete</v-icon>
              </v-btn>
               <v-btn
                v-if="items.item.id_estado!=7 && items.item.id_estado!=9"
                color="success"
               @click.prevent="aprobarAsistencia(items.item)"
                icon
                title="Aprobar asistencia"
              >
                <v-icon>done</v-icon>
              </v-btn> 
          
            <v-btn
                icon
                color="info"
              
                @click.native="verDocumento(items.item)"
                title="Ver documento"
              >
                <v-icon>attach_file</v-icon>
              </v-btn>
            </td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue";
import crud from "@/common/util/crud-table/mixins/crud-table";
import VerAsistencia from "./dialogs/VerAsistencia";
import AprobarAsistencia from "./dialogs/AprobarAsistencia";
import VerDocumento from "./dialogs/VerDocumento";
import VerReporte from "./dialogs/VerReporte";
export default {
  mixins: [crud],
  mounted() {
    
    this.$bus.$on("closeDialog", () => {
        this.updateList();
    });
        this.onFilter()
    this.getRolRecursosHumanos()
    this.getNombre()
  },
  data() {
    return {
      id_usuario:this.$route.params.id,
     
      graphql: true, // Definiendo el CRUD con Graphql
      url: "vAsistenciaManualCabeceras",
      esUsuario: this.$route.params.id,
    
      rol:[],
      rol2:[],
      rol3:[],
      nombres: "vAsistenciaManualCabeceras",
      initData: [
        {
          state: true,
          param: "id_persona",
          value: this.getPersonaId(),
        },
        {
          state: true,
          param: "autoridad",
          value: 1,
        },
        
      ],
      headers: [
        { text: "Nro", value: "id_permiso", sortable: false },
        { text: "Fecha de registro", value: "fecha_registro", sortable: false },
        { text: "Fecha inicio", value: "fecha_permiso", sortable: false },
        { text: "Fecha fin", value: "fecha_permiso", sortable: false },
        { text: "Estado", value: "id_estado", sortable: false },
        
        { text: this.$t("common.actions"), sortable: false },
      ],
      dataGraphql: `
        id
        id_estado
        estado
        nombres
        fecha_fin
        fecha_registro
        fecha_inicio
        ruta
        id_persona
      `,
      filters: [
         {
          field: "id",
          label: "Nro",
          type: "number",
          typeG: "String",
        },
       {
          field: "fecha_registro",
          label: "Fecha de registro",
          type: "text",
          typeG: "String",
        },
         {
          field: "fecha_inicio",
          label: "Fecha inicio",
          type: "text",
          typeG: "String",
        },
         {
          field: "fecha_fin",
          label: "Fecha fin",
          type: "text",
          typeG: "String",
        },
     
         {
          field: "estado",
          label: "Estado",
          type: "text",
          typeG: "String",
        },
      ],
      valid: true,
    };
  },
  methods: {
    verReporte(item){
      item.jefe=1
      this.$bus.$emit('openDialogVerReporte', item)
    },
    getPersonaId() {    
      return parseInt(this.$route.params.id);
    },
     verAsistencia(item) {
      item.esAutoridad=1
      this.$bus.$emit("openDialogVerAsistencia", item);
    },
   anularAsistencia(id) {
      const user = this.$storage.get("user");
      let fecha_actual = this.$moment(new Date()).format("YYYY/MM/DD");
		    let respuesta = "";
        this.$confirm("Usted esta seguro de anular el registro?", async() => {
        try {
            respuesta = await this.$service.graphql({
							query: `
								query{
								runQuery(consulta:"select control.fn_anula_aprueba_asistencia_manual(${parseInt(id)},9,${user.id},'${fecha_actual}')"){
									respuesta
								}
								}
							`
							});
              let resp=respuesta.runQuery.respuesta[0].fn_anula_aprueba_asistencia_manual 
							let resps2 = resp.split("|");
						
							let correcto = resps2[0];
							if (correcto == "1") {
										this.$confirm("El permiso fue anulado", () => {
									this.updateList()
										});
										}else{
								this.$message.warning(resps2[1])}
        } catch (error) {
          console.log(error)
        }
      });
    },
    aprobarAsistencia(item){
        item.esAutoridad=1
        this.$bus.$emit("openDialogAprobarAsistencia", item);
    },
      verDocumento(item) {
      this.$bus.$emit("openDialogVerDocumento", item);
    },
        async getNombre(){
        try {
        let res = await this.$service.graphql({
          query: `query{
            personas(id: ${this.getPersonaId()}){
              rows{
                id 
                ap_paterno
                ap_materno
                nombres
                ap_casada
              }
            }
          }
					`,
        });
        
        let persona = res.personas.rows[0];
        this.nombres = persona.ap_paterno+" "+persona.ap_materno+" "+persona.nombres;

        let user = this.$storage.get("user");
        this.rol=user.roles[0].id;
        for (let i = 0; i < user.roles.length; i++) {
          const element = user.roles[i];
          if (element.id==42 || element.id==32) {
             this.rol2=element.id;
          }else{
             this.rol2=0
          }
        }
       
      } catch (error) {
        console.log(error);
      }
    },
    getPersonaId() {
      const user = this.$storage.get("user");
    
      return this.$route.params.id?this.$route.params.id:user.id_persona;
    },
     getRolRecursosHumanos(){
        let user = this.$storage.get("user");
        let roles=user.roles
        let rol=null
       
        roles.forEach(element => {
            if (element.id==4 || element.id==32 ) {
             rol=4   
            }   
        });
      
        return rol
      },
     
  
  
  },
  components: {
    CrudTable,
    VerAsistencia,
  AprobarAsistencia,
  VerDocumento,
VerReporte,
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/admin/registro_manual_asistencia/ListadoRegistrosAsistenciaManualAutoridad.vue